import './UserBadge.scss';

export { default as UserBadge } from './UserBadge';
